document.addEventListener('DOMContentLoaded', function () {
  const tabs   = document.querySelectorAll('.tab-btn');
  const panels = document.querySelectorAll('.tab-panel');

  const initialPanel = document.querySelector('.tab-panel.active');
  if (initialPanel) {
    initialPanel.classList.add('first-load');

    setTimeout(() => {
      initialPanel.classList.remove('first-load');
    }, 1200);
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const targetId = this.getAttribute('data-tab');
      const currentPanel = document.querySelector('.tab-panel.active');
      const targetPanel  = document.getElementById(targetId);

      if (currentPanel === targetPanel) return;

      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      if (currentPanel) {
        currentPanel.classList.add('leaving');
        currentPanel.classList.remove('active');

        currentPanel.addEventListener('animationend', function handler() {
          currentPanel.classList.remove('leaving');
          currentPanel.style.display = 'none';
          currentPanel.removeEventListener('animationend', handler);

          if (targetPanel) {
            targetPanel.style.display = ''; 
            targetPanel.classList.add('active');
          }
        });
      } else {
        if (targetPanel) {
          targetPanel.style.display = '';
          targetPanel.classList.add('active');
        }
      }
    });
  });
});